import { render, staticRenderFns } from "./ChooseObjectTypeField.vue?vue&type=template&id=9f876606"
import script from "./ChooseObjectTypeField.vue?vue&type=script&lang=js"
export * from "./ChooseObjectTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports